import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { AdminForm, AdminLocationHierarchy, FormList, LocationNode } from 'Interfaces/Admin';

export interface AdminMetaState {
  loaded: boolean;
  formLists: FormList[];
  forms: AdminForm[];
  hierarchies: AdminLocationHierarchy[];
}

const INITIAL_STATE: AdminMetaState = {
  loaded: false,
  formLists: [],
  forms: [],
  hierarchies: [],
};

const adminMetaSlice = createSlice({
  name: 'adminMeta',
  initialState: INITIAL_STATE,
  reducers: {
    loadedFormsAndLists(state, action: PayloadAction<{ formLists: FormList[]; forms: AdminForm[] }>) {
      state.loaded = true;
      state.formLists = action.payload.formLists;
      state.forms = action.payload.forms;
    },
    loadedHierarchies(state, action: PayloadAction<AdminLocationHierarchy[]>) {
      state.hierarchies = action.payload;
    },
    /**
     *  Location nodes are fetched per hierarchy the first time a group using it
     *  is opened, then cached here — the legacy code cached them on the model.
     */
    loadedHierarchyLocations(
      state, action: PayloadAction<{ hierarchyId: number; locations: LocationNode[] }>,
    ) {
      const { hierarchyId, locations } = action.payload;
      const index = state.hierarchies.findIndex((h) => h.id === hierarchyId);
      if (index !== -1) {
        state.hierarchies[index].locations = locations;
      }
    },
    setFormListHasZip(state, action: PayloadAction<{ id: number; hasZip: boolean }>) {
      const list = state.formLists.find((f) => f.id === action.payload.id);
      if (list) {
        list.hasZip = action.payload.hasZip;
      }
    },
  },
});

export const {
  loadedFormsAndLists, loadedHierarchies, loadedHierarchyLocations, setFormListHasZip,
} = adminMetaSlice.actions;

export default adminMetaSlice.reducer;
